/*
 * Dependencies:
 * - FB api if you want facebook share (https://developers.facebook.com/docs/javascript/reference/FB.ui)
 */

define('components/factory/views/ShareView', [
    'components/factory/templates/shareview'
], function(tpl) {

    var ShareView = Mazarine.View.extend({

        events: {
            "click .js-maz-btn-share": "onClickButtonShare",
            "click .js-maz-sprite-social-link": "onClickButtonEmbed"
        },

        template: tpl,

        className: "maz-share-view",

        afterRender: function() {
            this.model.set('isReady', true);
        },

        showEmbedTooltip: function() {
            this.$('.maz-social-tooltip').css('display', "inline");
        },

        hideEmbedTooltip: function() {
            this.$('.maz-social-tooltip').css('display', "none");
        },

        onClickButtonEmbed: function( e ) {
            e.preventDefault();
            this.showEmbedTooltip();

            // Close on click outside
            $(document).on('mousedown.shareview', _.bind(function(e){
                var $target = $(e.target);

                if ($target.parents().index(this.$('.maz-social-tooltip')) === -1) {
                    this.hideEmbedTooltip();
                }
                $(document).off('.shareview');
            }, this));
        },

        onClickButtonShare: function( e ) {
            var $currentTarget = $( e.currentTarget );
            var socialName = "";

            if ($currentTarget.hasClass('maz-btn-share-facebook')) {
                e.preventDefault();
                socialName = "facebook";
                this.feedFacebook( this.model.get('facebookShare') );
            } else if ($currentTarget.hasClass('maz-btn-share-twitter')) {
                e.preventDefault();
                socialName = "twitter";
                this.shareTwitter( this.model.get('twitterShare') );
            } else if ($currentTarget.hasClass('maz-btn-share-weibo')) {
                e.preventDefault();
                socialName = "weibo";
                this.shareWeibo( this.model.get('weiboShare') );
            }

            var callback = this.model.get("onShareCallback");

            if( callback ) {
                callback( socialName );
            }
        },

        feedFacebook: function( shareObj ){
            if( !shareObj ){
                console.warn("[ShareView -> feedFacebook] shareObj can't be null");
                return;
            }

            var link = shareObj.link ? shareObj.link : window.location.href;
            var name = shareObj.name ? shareObj.name : '';
            var caption = shareObj.caption ? shareObj.caption : '';
            var description = shareObj.description ? shareObj.description : '';

            //Fix picture url on preproduction and production, url need http:// or https:// on prefix url
            var protocolPictureUrl = '';
            if( this.model.get('config').environement !== 'development' ){
                protocolPictureUrl = window.location.protocol;
            }

            var picture = shareObj.picture ? (protocolPictureUrl + this.model.get('base_url') + this.model.get('assets_url') + shareObj.picture) : '';

            console.log("[ShareView -> feedFacebook] Sharing "+link+" name="+name+" caption="+caption+" description="+description+" picture="+picture);

            FB.ui({
                "method": 'feed',
                "link": link,
                "name": name,
                "caption": caption,
                "description": description,
                "picture": picture
            });
        },

        shareTwitter: function( shareObj ) {
            if( !shareObj ){
                console.warn("[ShareView -> shareTwitter] shareObj can't be null");
                return;
            }

            var twitterUrl = "https://twitter.com/intent/tweet?";
            var twitterParameters = [];

            if (shareObj.text) {
                twitterParameters.push( "text=" + encodeURIComponent( shareObj.text ) );
            }

            if (!shareObj.url) {
                shareObj.url = window.location.href;
            }
            if (shareObj.url) {
                twitterParameters.push( "url=" + encodeURIComponent( shareObj.url ) );
            }

            if (shareObj.hashtags) {
                twitterParameters.push( "hashtags=" + encodeURIComponent( shareObj.hashtags ) );
            }

            if (shareObj.via) {
                twitterParameters.push( "via=" + encodeURIComponent( shareObj.via ) );
            }

            twitterUrl += twitterParameters.join("&");

            window.open(twitterUrl, '_blank');
        },

        shareWeibo: function( shareObj ) {
            if( !shareObj ){
                console.warn("[ShareView -> shareWeibo] shareObj can't be null");
                return;
            }

            var weiboUrl = "http://service.weibo.com/share/share.php?";
            var weiboParameters = [];

            if (shareObj.title) {
                weiboParameters.push( "title=" + encodeURIComponent( shareObj.title ) );
            }

            if (!shareObj.url) {
                shareObj.url = window.location.href;
            }
            if (shareObj.url) {
                weiboParameters.push( "url=" + encodeURIComponent( shareObj.url ) );
            }

            weiboUrl += weiboParameters.join("&");

            window.open(weiboUrl, '_blank');
        }

    });

    return ShareView;
});
